var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7499 4.24994C16.7499 3.55956 16.1904 3 15.5 3C14.8096 3 14.2501 3.55956 14.2501 4.24994H10.5C10.5 3.55956 9.94027 3 9.24989 3C8.55951 3 7.99996 3.55956 7.99996 4.24994C5.2385 4.24994 3 6.48843 3 9.24989V23.0002C3 25.7616 5.2385 28.0001 7.99996 28.0001H23C25.7615 28.0001 28 25.7616 28 23.0002V9.24989C28 6.48843 25.7615 4.24994 23 4.24994C23 3.55956 22.4405 3 21.7501 3C21.0597 3 20.5 3.55956 20.5 4.24994H16.7499ZM20.5185 20.3887C15.5743 22.5965 15.5222 22.6097 10.861 20.4857L10.7875 15.3009C15.6667 18.1235 15.7728 18.1183 20.4435 15.0956C20.4559 15.9772 20.4739 17.2413 20.4906 18.416C20.5009 19.1458 20.5108 19.8411 20.5185 20.3887ZM8.74401 18.6023C9.13979 18.4088 9.13144 17.8264 8.73024 17.6487C8.71081 16.2687 8.64774 14.7926 8.57716 13.7734L15.7033 16.7295L24.1644 12.6143L15.6594 9L7 13.119L8.33423 13.6725C8.32045 14.488 8.32271 15.7665 8.34925 17.6379C7.89363 17.8085 7.90322 18.4758 8.36325 18.6279L7.96939 22.9755C8.403 22.6973 8.8584 22.7391 9.21601 22.9505L8.74401 18.6023Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademic);
export default __webpack_public_path__ + "static/media/Academic.8ac088b534bad3369874eb9c79e17566.svg";
export { ForwardRef as ReactComponent };